<template>
  <div class="auth">
    <div v-if="showLogin">
      <div class="auth__container">
        <div class="title">Вход</div>
        <div class="info">Введите логин и пароль</div>
        <input type="text" placeholder="Логин" v-model="login" />
        <input type="password" placeholder="Пароль" v-model="password" />
        <button class="btn btn-auth btn-gradient" @click="onLogin">Войти</button> 
        <!-- <div class="reset" @click="showLogin = false">Забыли пароль?</div> -->
      </div>
    </div>
    <!-- <div v-else>
      <div class="auth__container">
        <div class="title">Восстановление пароля</div>
        <div class="info">Введите E-mail для восстановления пароля</div>
        <input type="text" placeholder="E-mail" v-model="reset.email">
        <button class="btn btn-auth btn-gradient btn-reset" @click="onReset">Восстановить пароль</button>
      </div>
    </div> -->
  </div>
</template>


<script>
import axios from 'axios';

export default {
  name: 'AuthMain',

  data: () => ({
    showLogin: true,
    login: '',
    password: '',
    // reset: {
    //   email: '',
    // },
  }),

  mounted() {
    this.$store.dispatch('checkToken');
  },

  methods: {
    // async onReset() {
    //   try {
    //     await axios.post(`/api/email`, { email: this.reset.email, platform: 'web' });
    //     this.$bus.$emit('showNotification', { message: 'Письмо отправлено на вашу почту!', status: 'success' });
    //   } catch(err) {
    //     console.error(err);
    //     this.$bus.$emit('showNotification', { message: err.response.data, status: 'danger' });
    //   };
    // },

    async onLogin() {
      try {
        const payload = { login: this.login, password: this.password };
        const headers = { 'Content-type': 'application/json; charset=UTF-8' };
        const response = await axios.post(`/api/auth/login`, payload, { headers });
        this.$store.dispatch('createToken', response.data);
        this.$router.push('/admin');
      } catch(err) {
        console.error(err);
        this.$bus.$emit('showNotification', { message: err.response.data, status: 'danger' });
      };
    },
  },
};
</script>


<style lang="scss" scoped>
.auth {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  color: #00325C;
  text-align: center;
  div {
    .auth__container {
      display: flex;
      flex-direction: column;
      width: 350px;
      .title {
        font-size: 30px;
        font-weight: 500;
        margin-bottom: 15px;
      }
      .info {
        font-size: 14px;
        margin-bottom: 20px;
      }
      .reset {
        margin-top: 10px;
        font-size: 12px;
        cursor: pointer;
      }
      .btn {
        margin: 10px auto;
        width: 50%;
      }
      input {
        margin-bottom: 15px;
        &[type="submit"] {
          width: 45%;
          margin: 15px 95px;
          &.btn-reset {
            width: 58%;
            margin: 15px 73px;
          }
        }
      }
    }
  }
}
</style>